import React, {useState, useEffect} from 'react';
import {Bar, Line, Pie} from 'react-chartjs-2';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { chartBlue, chartRed } from '../common/theme';
import {isObjectEmpty, weekdayNames, arrayCounter, getTotalForItem, differenceInDays, timeConverterSM, timeConverterChart, dateMinusDays} from '../../Utils';

const ChartComp = props => {

  if(isObjectEmpty(props.data)) return<>Loading</>;
  return (
    <div>

    <Container>
      <Row>
        <Col>
          <Bar
            data={props.data.activitySummaryData}
            options={{
              title:{
                display:props.displayTitle,
                text: props.data.activitySummaryDataTitle,
                fontSize:16
              },
              legend:{
                display:props.displayLegend,
                position:props.legendPosition
              }
            }}
          />
        </Col>
        <Col>
        <Pie
            data={props.data.accuracySummaryData}
            options={{
              title:{
                display:props.displayTitle,
                text:props.data.accuracySummaryDataTitle,
                fontSize:16
              },
              legend:{
                display:props.displayLegend,
                position:props.legendPosition
              }
            }}
          />            
        </Col>
      </Row>
      <Row>
        <Col>            
        <Line
            data={props.data.timeSummaryData}
            options={{
              title:{
                display:props.displayTitle,
                text:props.data.timeSummaryDataTitle,
                fontSize:16
              },
              legend:{
                display:props.displayLegend,
                position:props.legendPosition
              }
            }}
          />
        </Col>
        <Col>
          <Bar
            data={props.data.loginSummaryData}
            options={{
              title:{
                display:props.displayTitle,
                text:props.data.loginSummaryDataTitle,
                fontSize:16
              },
              legend:{
                display:props.displayLegend,
                position:props.legendPosition
              }
            }}
          />            
        </Col>
      </Row>
    </Container>
  </div>
  );
};

ChartComp.propTypes = {
  data: PropTypes.object,
  displayTitle: PropTypes.bool,
  displayLegend: PropTypes.bool,
  legendPosition: PropTypes.string,
};

ChartComp.defaultProps = {
    displayTitle:true,
    displayLegend: true,
    legendPosition:'right'
}; 

const ContainerComp = ({pageState}) =>{
  const [componentData, setComponentData] = useState({});

  useEffect(() =>{tryLoadingNow();},[pageState.summaryData]);
  useEffect(() =>{tryLoadingNow();},[pageState.dateRange]);

  const tryLoadingNow = () => {
    const {summaryData, dateRange} = pageState;

    if(isObjectEmpty(summaryData)) return;
    if(!dateRange || dateRange.length==0) return;

    let numOfDays = differenceInDays(dateRange[0], dateRange[1]);

    var date = new Date(dateRange[1]);
    date.setHours(0,0,0,0);

    let totalCorrect = 0;//getTotalForItem(summaryData, 'QuestionsRight');
    let totalAnswered = 0;//getTotalForItem(summaryData, 'QuestionsAttempted');

    
    let colTitleTimesCompleted = [], colDataTimesCompleted = [], colDataTimesMastered = [], 
        colDataTimeSpent = [], colDataLogins = [];        

    for(let i=0; i<numOfDays; i++){          
      let d = dateMinusDays(date.getTime(),i);
      // let marksForDay = summaryData.filter((summaryRec)=>parseInt(summaryRec['DayDate'])===d.getTime());
      let marksForDay = summaryData.filter((summaryRec)=>{
        let newDate = new Date(parseInt(summaryRec['DayDate']));
        newDate.setHours(0,0,0,0);
        return newDate.getTime()===d.getTime();
      });
      //colTitleTimesCompleted.push(weekdayNames[d.getDay()]);
      colTitleTimesCompleted.push(timeConverterChart(d.getTime()));
      colDataTimesCompleted.push(getTotalForItem(marksForDay, 'TimesCompleted'));
      colDataTimesMastered.push(getTotalForItem(marksForDay, 'TimesMastered'));
      //colDataTimeSpent.push(getTotalForItem(marksForDay, 'CumulativeTime')+getTotalForItem(marksForDay, 'CumulativeIdleTime'));
      colDataTimeSpent.push(getTotalForItem(marksForDay, 'CumulativeTime'));
      totalCorrect += getTotalForItem(marksForDay, 'QuestionsRight');
      totalAnswered += getTotalForItem(marksForDay, 'QuestionsAttempted');
      colDataLogins.push(marksForDay.length);
    }
    
    let totalIncorrect = totalAnswered - totalCorrect;
    let accurracyPerecent = Math.round((totalCorrect/totalAnswered)*100);

    let max = Math.max(...colDataTimeSpent);
    let timeType = (max > 120000)?(max > 7200000)?'Hours':'Mins':'Secs';
    colDataTimeSpent = colDataTimeSpent.map((e)=> (timeType === 'Secs') ? Math.ceil(e/1000) : (timeType === 'Mins') ? Math.ceil(e/60000) : Math.ceil(e/3600000));
    let totalTime = arrayCounter(colDataTimeSpent);
    let totalTimeType = {type:'Secs', time:totalTime}; 
    
    if((timeType === 'Secs' && totalTime >= 120)) totalTimeType = {type:'Mins', time:Math.ceil(totalTime/60)};
    if((timeType === 'Secs' && totalTime < 120)) totalTimeType = {type:'Secs', time:totalTime };
    if((timeType === 'Mins' && totalTime >= 120)) totalTimeType = {type:'Hours', time:Math.ceil(totalTime/60)};
    if((timeType === 'Mins' && totalTime < 120)) totalTimeType = {type:'Mins', time:totalTime };
    if((timeType === 'Hours' && totalTime >= 48)) totalTimeType = {type:'Days', time:Math.ceil(totalTime/24)};
    if((timeType === 'Hours' && totalTime < 48)) totalTimeType = {type:'Hours', time:totalTime };
    
    let totalCompleted = arrayCounter(colDataTimesCompleted);
    let totalLogins = arrayCounter(colDataLogins);

    setComponentData( { 
      totalLogins, 
      activitySummaryDataTitle:`Activities Completed (${totalCompleted})`,
      accuracySummaryDataTitle:`Accuracy Score (${accurracyPerecent} %)`,
      timeSummaryDataTitle:`Time Spent (${totalTimeType.time} ${totalTimeType.type})`,
      loginSummaryDataTitle:`Logins(${totalLogins})`,

      activitySummaryData:{
        labels: colTitleTimesCompleted.reverse(),
        datasets:[
          {
            label: 'Completed',
            backgroundColor: chartBlue,
            data: colDataTimesCompleted.reverse()
          }, {
            label: 'Mastered',
            backgroundColor: chartRed,
            data: colDataTimesMastered.reverse()
          }
        ]
      },

      accuracySummaryData:{
        labels: ['Correct', 'Incorrect'],
        datasets:[
          {
            data:[
              totalCorrect,
              totalIncorrect
            ],
            backgroundColor:[
              chartBlue,
              chartRed
            ]
          }
        ]
      },      

      timeSummaryData:{
        labels: colTitleTimesCompleted.reverse(),
        datasets:[
          {
            label: timeType,
            backgroundColor: chartBlue,
            data: colDataTimeSpent.reverse()
          }
        ]
      },

      loginSummaryData:{
        labels: colTitleTimesCompleted.reverse(),
        datasets:[
          {
            label: 'Logins',
            backgroundColor: chartBlue,
            data: colDataLogins.reverse()
          }
        ]
      },
    });
  };

// eslint-disable-next-line react/display-name
return <>
{/* componentData.totalLogins>1200 && <center style={{color:'red'}}>*** This summary might be incomplete, please try changing to a smaller date range ***</center> */}  
{!isObjectEmpty(pageState.summaryData) &&
  <div><ChartComp data={componentData}/></div>}
</>;
};

export default ContainerComp;